import React from "react";
import { Divider } from "semantic-ui-react";
import styled from "styled-components";

import { BasicContainer, Value, QuestionTitle, FlexDiv } from "../shared";

interface Props {
  additionalInfo: { [key: string]: any };
}

const Signature: React.FC<Props> = ({ additionalInfo }) => {
  const { name, phone, email, signature, verified } = additionalInfo;

  return (
    <BasicContainer>
      <QuadrupleInputGrid>
        <div>
          <QuestionTitle>Signature</QuestionTitle>
          <Value>{signature ?? "--"}</Value>
        </div>
        <div>
          <QuestionTitle>Name</QuestionTitle>
          <Value>{name ?? "--"}</Value>
        </div>
        <div>
          <QuestionTitle>Phone</QuestionTitle>
          <Value>{phone ?? "--"}</Value>
        </div>
        <div>
          <QuestionTitle>Email</QuestionTitle>
          <Value>{email ?? "--"}</Value>
        </div>
      </QuadrupleInputGrid>
      <Divider />
      <StyledFlexDiv>
        <input type="checkbox" checked={verified} />
        <label>
          I have compiled a service line inventory for this water system based
          upon a review of the above referenced records and investigations in
          accordance with 40 CFR Part 141, Subpart 1
        </label>
      </StyledFlexDiv>
    </BasicContainer>
  );
};

export const QuadrupleInputGrid = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;
  & > h3 {
    grid-column-start: span 2;
  }
  & > div.field {
    margin: 0 !important;
  }
`;

const StyledFlexDiv = styled(FlexDiv)`
  pointer-events: none;
`;

export default Signature;
